import { RecentPattern } from "../types/pattern";

// Mock data for recent patterns
export const recentPatterns: RecentPattern[] = [
  {
    id: "1",
    title: "Hero Section",
    preview: "A hero section with gradient background and two columns",
    date: new Date(2023, 6, 15),
  },
  {
    id: "2",
    title: "Pricing Table",
    preview: "A responsive pricing table with three tiers",
    date: new Date(2023, 6, 10),
  },
  {
    id: "3",
    title: "Testimonial Grid",
    preview: "A grid of customer testimonials with images",
    date: new Date(2023, 6, 5),
  },
];
